import BusStopData from '../../schema/viewSchema/BusStopData';
import FlightReservation from '../../schema/FlightReservation';
import TxpStrings from '../../schema/configSchema/TxpStrings';
import { utcDate, differenceInSeconds } from 'owa-datetime';

// Extracts the flight specific data needed for displaying the bus stop
export default function populateFlightBusStopData(
    flightEntity: FlightReservation,
    txpStrings: TxpStrings,
    entityIcon: string
): BusStopData {
    let {
        departureTime,
        arrivalTimeUTC,
        departureTimeUTC,
        departureAirport,
        arrivalAirport,
        airline,
        flightNumber,
    } = flightEntity;
    let departureTimeDisplayText = txpStrings.formatters.formatUserTime(departureTime);
    let departureDateAriaText = txpStrings.formatters.formatWeekDayMonthDayYear(departureTime);
    /** new Date is used for comparing differences between same Time zones- work item 22001 to avoid it */
    let durationString: string = null;
    if (arrivalTimeUTC && departureTimeUTC) {
        let departureTimeInUTC = utcDate(departureTimeUTC);
        let arrivalTimeInUTC = utcDate(arrivalTimeUTC);
        let duration: number = differenceInSeconds(arrivalTimeInUTC, departureTimeInUTC);
        durationString = txpStrings.formatters.durationFormatter(duration);
    }

    let collapsedTextString = '';
    if (durationString) {
        collapsedTextString = txpStrings.formatters.format(
            txpStrings.strings.flightBusStopSummaryWithDurationFormatText,
            departureAirport.city,
            txpStrings.formatters.formatWeekDayDateTime(departureTime),
            durationString
        );
    } else {
        collapsedTextString = txpStrings.formatters.format(
            txpStrings.strings.flightBusStopSummaryFormatText,
            departureAirport.city,
            txpStrings.formatters.formatWeekDayDateTime(departureTime)
        );
    }

    let ariaBusStopText = txpStrings.formatters.format(
        txpStrings.strings.flightBusStopAriaText,
        departureAirport.city,
        departureDateAriaText,
        departureTimeDisplayText
    );

    return {
        busStopLabel: txpStrings.strings.flightBusStopLabelText,
        busStopText: txpStrings.formatters.format(
            txpStrings.strings.flightBusStopFirstLineFormatText,
            airline.name,
            airline.iataCode,
            flightNumber,
            arrivalAirport.city
        ),
        collapsedText: collapsedTextString,
        ariaBusStopText: ariaBusStopText,
        icon: entityIcon,
    } as BusStopData;
}
